define(
({
  "alert": "Varning",
  "okay": "OK"
})
);
